import firebase from "firebase";

  // Your web app's Firebase configuration
  var firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDLfuAdxQMyqmMYFQDmEOA4lL7XjQU1_H8",
    authDomain: "portfolio-contact-form-5226f.firebaseapp.com",
    projectId: "portfolio-contact-form-5226f",
    storageBucket: "portfolio-contact-form-5226f.appspot.com",
    messagingSenderId: "244719851695",
    appId: "1:244719851695:web:fadedf030a7c36af019c5a"
  });

var db = firebaseApp.firestore();

export { db };



